import { gql } from '@apollo/client/core';
import { pageAssemblyFragment } from './page-assembly.fragment';
import { signpostContentBlockFragment } from './signpost-content-block.fragment';

export const signpostBlockFragment = gql`
  fragment SignpostBlockFields on SignpostBlock {
    entryTitle
    columns
    signpostTitle
    blocksCollection(limit: 10) {
      items {
        __typename
        ...PageAssemblyFields
        ...SignpostContentBlockFields
      }
    }
  }
  ${pageAssemblyFragment}
  ${signpostContentBlockFragment}
`;
